import Axios from 'axios';

export const uploadImagemAws = ({ url, file }) => {
  const options = {
    headers: {
      'Content-Type': file.type
    }
  };

  return Axios.put(url, file, options);
};

export default { uploadImagemAws };
